define.alias("shared/components/shared/instagram-business/upgrade-button", "auth/components/shared/instagram-business/upgrade-button");